<div class="container-fluid lh-container-fluid">
  <div class="block-1">
    <div class="row">
      <div class="col-12 col-sm-6">
        <h1>{{ 'EARN_MORE_WITHOUT_EXTRA_COST' | translate }}</h1>
        <p>{{ 'DRIVE_FOOT_TRAFFIC_AND_ADD_REVENUE' | translate }}</p>

        <div class="cta">
          <a
            id="signUpStorageManager"
            routerLink="/dashboard"
            class="btn btn-warning btn-md btn-block d-block d-sm-none"
            >{{ 'SIGN_UP' | translate }}</a
          >
          <a id="signUpStorageManager" routerLink="/dashboard" class="btn btn-warning btn-lg d-none d-sm-block">{{
            'SIGN_UP' | translate
          }}</a>
          <!-- <span>
          {{ 'Already have an account?' | translate }}
          <a id="signInStorageManager" routerLink="/dashboard">{{ 'SIGN_IN' | translate }}</a>
        </span> -->
        </div>
      </div>

      <div class="col-12 col-sm-6 image-container">
        <img src="/assets/LuggageHero_figur_fod-paa-kufferter-1-720x907.png" />
      </div>
    </div>
  </div>
</div>

<div class="alt-background">
  <div class="container-fluid lh-container-fluid">
    <div class="block-2">
      <div class="row">
        <div class="col-12">
          <h3>{{ 'HOW_DOES_IT_WORK' | translate }}</h3>
          <p>{{ 'STORAGE_MANAGER_HOW_DOES_IT_WORK_PART_1' | translate }}</p>
          <p>{{ 'STORAGE_MANAGER_HOW_DOES_IT_WORK_PART_2' | translate }}</p>
          <button class="btn btn-md btn-primary" routerLink="/dashboard">{{ 'GET_STARTED' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
